<template>
  <div
    class="category-card"
    @click="hanldeClick"
  >
    <div
      class="title-wrap"
      :class="{ read : !item.currentUserRead }"
    >
      <div
        class="dot"
        v-if="!item.currentUserRead"
      />
      <div>{{ item.title }}</div>
    </div>
    <div class="artcle-wrap">
      <div>更新时间：{{ item.updatedTime }}</div>
      <div class="button">开始学习</div>
    </div>
  </div>
</template>

<script >
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {

    };
  },
  methods: {
    hanldeClick() {
      this.$emit('click', this.item);
    }
  }
};

</script>

<style lang="scss" scoped>
  .category-card {
    background: #FFFFFF;
    border-radius: 8px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    padding: 16px 12px 12px 12px;

    .title-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-bottom: 12px;
      color: #383838;
      word-break: break-all;

      .dot {
        background-color: #F32222;
        margin-right: 4px;
        margin-left: 4px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
      }

    }

    .read {
        color: #646464;
    }

    .artcle-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      font-weight: 400;
      height: 24px;

      .button {
        display: flex;
        background: #E6F2FF;
        border-radius: 15pt;
        width: 70px;
        height: 24px;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #3399FF;
      }
    }
  }

</style>
